import {
  Currency,
  createExtensionValue,
  ExtensionUrl,
} from '@quromedical/fhir-common';

import { type ChargeItemDefinitionMoney, MONEY_FACTOR } from './schema';

const currencies = Object.values(Currency);
export const isCurrency = (currency?: string): currency is Currency =>
  currencies.includes(currency as Currency);

export const isCentsFactor = (factor?: number): factor is typeof MONEY_FACTOR =>
  factor === MONEY_FACTOR;

export const mapFhirToMoney = (
  factor?: number,
  money?: fhir4.Money,
): ChargeItemDefinitionMoney | undefined => {
  const value = money?.value;
  const currency = money?.currency;
  const isCurrencyValid = isCurrency(currency);
  const isFactorValid = isCentsFactor(factor);

  const isValid = value && isFactorValid && isCurrencyValid;

  if (!isValid) {
    return undefined;
  }

  return {
    currency,
    factor,
    value,
  };
};

const createMoneyFactorExtension = createExtensionValue(
  ExtensionUrl.moneyFactor,
);

/**
 * Map a money amount to a FHIR money type with a Factor Extension
 */
export const mapMoneyToFhir = (
  money: ChargeItemDefinitionMoney,
): fhir4.Money => {
  const moneyFactor = createMoneyFactorExtension(money.factor);

  return {
    extension: [moneyFactor],
    currency: money.currency,
    value: money.value,
  };
};
